import { useState, type ReactNode } from 'react';
import { SidebarContext } from './useSidebar';

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [expandedMenus, setExpandedMenus] = useState<Set<string>>(
    new Set(['Incidents']),
  );

  const toggleMenu = (menuName: string) => {
    setExpandedMenus((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(menuName)) {
        newSet.delete(menuName);
      } else {
        newSet.add(menuName);
      }
      return newSet;
    });
  };

  const isMenuExpanded = (menuName: string) => {
    return expandedMenus.has(menuName);
  };

  return (
    <SidebarContext.Provider value={{ expandedMenus, toggleMenu, isMenuExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
}
